module.exports = __webpack_public_path__ + "img/MHL_Bottles_Single.2c710a84.png";